import { render } from "./DashboardEditarOrdenEntrega.vue?vue&type=template&id=50475fa5&scoped=true"
import script from "./DashboardEditarOrdenEntrega.vue?vue&type=script&lang=js"
export * from "./DashboardEditarOrdenEntrega.vue?vue&type=script&lang=js"

import "./DashboardEditarOrdenEntrega.vue?vue&type=style&index=0&id=50475fa5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50475fa5"]])

export default __exports__